import { FuelLoading } from '@frete.com/fuel-react';
import styled, { css } from 'styled-components';

const gridColumns = { sm: 4, md: 2, lg: 1 } as const;

export const FormContainer = styled.div`
  ${({ theme: { grid, breakpoint } }) => css`
    display: grid;
    grid-template-columns: repeat(${gridColumns.sm}, 1fr);
    grid-gap: ${grid.sm.gutter};

    @media (min-width: ${breakpoint.md.minWidth}) {
      grid-gap: ${grid.md.gutter};
    }

    @media (min-width: ${breakpoint.lg.minWidth}) {
      grid-gap: ${grid.lg.gutter};
    }
  `}
`;

export const FormRow = styled(FormContainer)`
  ${() => css`
    grid-column: 1 / ${gridColumns.sm + 1};
  `}
`;

export const FormItem = styled.div<{ sm?: number; md?: number; lg?: number }>`
  ${({ theme: { breakpoint }, sm = gridColumns.sm, md = gridColumns.md, lg = 1 }) => css`
    display: grid;
    grid-column: auto/span ${sm};

    @media (min-width: ${breakpoint.md.minWidth}) {
      grid-column: auto/span ${md};
    }

    @media (min-width: ${breakpoint.lg.minWidth}) {
      grid-column: auto/span ${lg};
    }
  `}
`;

export const LoadingInputWrapper = styled(FormItem)`
  position: relative;
`;

export const LoadingInput = styled(FuelLoading)`
  ${({ theme: { color } }) => css`
    color: ${color.icon.brand.default};
    position: absolute;
    right: 0.875rem;
    top: 2.56rem;
    width: 1.25rem;
    height: 1.25rem;
  `}
`;
